module.exports = "<span class=\"y-poper-text\" data-bind=\"html:text\"></span>";


//////////////////
// WEBPACK FOOTER
// ./src/components/popper/index.html
// module id = 497
// module chunks = 0